import { ISearch } from './ISearch.model';
import { ActionPlanItem } from './action-plan-item.model';
import { ActionPlanGroupedItemsModel } from './action-plan-grouped-items.model';
import { Inspection } from './inspection.model';
import { ActionPlanPlugin } from './action-plan-plugin.model';
import * as _ from 'lodash';

export class ActionPlanModel implements ISearch {
  public actionPlanItems: ActionPlanItem[] = [];
  public isLoaded: Boolean;
  public actionPlansItemsById: any = {};
  public responsibleList: ActionPlanGroupedItemsModel[] = [];
  public inspection: Inspection;
  public prog: number;
  public applicationType: number;
  public inspectionId: string;
  public plugins: ActionPlanPlugin[] = [];
  public pluginsById: any = {};
  public allPlugins: ActionPlanPlugin[] = [];
  public inputLanguage: string;
  public translations: any;

  public search(query: string): boolean {
    if (query == null || (typeof query === 'string' && query.trim() === '')) {
      return true;
    }
    let queryToLower = query.toLowerCase();
    return (
      (this.name != null && this.name.toLowerCase().indexOf(queryToLower) !== -1) ||
      (this.description != null && this.description.toLowerCase().indexOf(queryToLower) !== -1)
    );
  }

  constructor(public id: string, public name: string, public description: string) {}
}
